import { PropsWithChildren } from "react";
import { Row } from "@tanstack/react-table";

interface TableRowProps
  extends PropsWithChildren,
    React.HTMLAttributes<HTMLDivElement> {
  row?: Row<any>;
}

export const TableRow = ({ children, row, ...props }: TableRowProps) => {
  const handleClick = () => {
    if (row && row.getCanSelect()) {
      row.toggleSelected(!row.getIsSelected());
    }
  };

  return (
    <div
      className="flex flex-row items-center w-full h-fit relative border-b"
      // _hover={{ background: row?.getCanSelect() && row?.getIsSelected() ? '#f9effd' : '#F5F5F5'}}
      // background={row?.getCanSelect() && row?.getIsSelected() ? '#f9effd' : 'white'}
      onClick={handleClick}
      // borderBottom="0.5px solid #E2E8F0"
      {...props}
    >
      {children}
    </div>
  );
};
